import { render, staticRenderFns } from "./ObratySkladuDlePracovnika.vue?vue&type=template&id=327fb6f6&"
import script from "./ObratySkladuDlePracovnika.vue?vue&type=script&lang=ts&"
export * from "./ObratySkladuDlePracovnika.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports